import http from './http';

export default {
  getTicketFilters({
    wheelId,
    wheelAccountId,
    dateFrom,
    dateTo,
    betChannelId,
    timezone,
    timezoneOffset,
  }) {
    return http.get('/tickets/filters', {
      params: {
        wheelId,
        wheelAccountId,
        dateFrom,
        dateTo,
        betChannelId,
        timezone,
        timezoneOffset,
      },
    }).then((response) => {
      const result = response.data;
      return result;
    });
  },
  getTickets({
    wheelId,
    wheelAccountId,
    dateFrom,
    dateTo,
    format,
    page,
    pageSize,
    paymentBetshop,
    paymentOperator,
    paymentRetailRegister,
    players,
    betChannelId,
    sortBy,
    sortOrder,
    search,
    status,
    locale,
    timezone,
    timezoneOffset,
  }) {
    return http.get(`/tickets/${wheelId}`, {
      params: {
        wheelAccountId,
        dateFrom,
        dateTo,
        format,
        page,
        pageSize,
        paymentBetshop,
        paymentOperator,
        paymentRetailRegister,
        players,
        betChannelId,
        sortBy,
        sortOrder,
        search,
        status,
        locale,
        timezone,
        timezoneOffset,
      },
    }).then((response) => {
      const result = response.data;
      return result;
    });
  },
  getTicketBets({
    wheelId,
    wheelAccountId,
    ticketId,
    locale,
  }) {
    return http.get(`/tickets/${wheelId}/${ticketId}/bets`, {
      params: {
        wheelAccountId,
        locale,
      },
    }).then((response) => {
      const result = response.data;
      return result;
    });
  },
};
